import * as React from 'react';
export default function SvgDelay() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.238 7.369a.75.75 0 0 1 .75-.75h3.991a.75.75 0 1 1 0 1.5H9.988a.75.75 0 0 1-.75-.75ZM11.617 9.196a.75.75 0 0 0 0 1.5h.733a.75.75 0 1 0 0-1.5h-.733Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.148 4.302A.75.75 0 0 1 5.75 4h12.5a.75.75 0 0 1 .718.965l-1.097 3.66A5.95 5.95 0 0 1 15.445 12a5.948 5.948 0 0 1 2.426 3.375l1.097 3.66a.75.75 0 0 1-.718.965H5.75a.75.75 0 0 1-.718-.965l1.097-3.66A5.95 5.95 0 0 1 8.555 12a5.95 5.95 0 0 1-2.426-3.375l-1.097-3.66a.75.75 0 0 1 .116-.663ZM6.758 5.5l.81 2.704.006.019a4.45 4.45 0 0 0 2.91 3.064.75.75 0 0 1 0 1.426 4.451 4.451 0 0 0-2.91 3.064l-.006.02-.81 2.703h10.484l-.81-2.704-.006-.019a4.45 4.45 0 0 0-2.91-3.064.75.75 0 0 1 0-1.426 4.451 4.451 0 0 0 2.91-3.064l.006-.02.81-2.703H6.758Z",
    fill: "currentColor"
  }));
}